<template>
  <InputLayout>
    <template #icon>
      <DialpadIcon />
    </template>

    <input
      name="number"
      autocomplete="off"
      v-model="value"
      v-focus
      @keyup.enter="callNumber"
      placeholder="Enter a phone number" />
      <template #button>
        <button @click="backspace">
          <font-awesome-icon :icon="faBackspace" />
        </button>
      </template>

  </InputLayout>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBackspace } from '@fortawesome/pro-light-svg-icons/faBackspace'
import DialpadIcon from '@/components/shared/DialpadIcon'
import InputLayout from '../shared/InputLayout'

const { mapState, mapActions } = createNamespacedHelpers('dialer')

export default {
  components: {
    InputLayout,
    FontAwesomeIcon,
    DialpadIcon
  },
  data () {
    return {
      faBackspace
    }
  },
  computed: {
    ...mapState([
      'number'
    ]),
    value: {
      get () {
        return this.number
      },
      set (value) {
        this.setNumber(value)
      }
    }
  },
  methods: {
    ...mapActions([
      'setNumber'
    ]),
    callNumber () {
      this.$router.push({
        path: 'phone-controller',
        query: {
          type: encodeURIComponent('JIMINNY.SOFTPHONE.PHONE'),
          phone: encodeURIComponent(this.number)
        }
      })
    },
    backspace () {
      this.setNumber(this.number.slice(0, -1))
    }
  }
}
</script>



// WEBPACK FOOTER //
// NumberDisplay.vue?50976be0